const announcementsDE = {
    "view": {
        "dropdown": {
            "unreadHeading": "{{count}} ungelesene Ankündigungen",
            "empty": "Keine Ankündigungen",
            "newBadge": "Neu",
            "dismissAll": "Alle verwerfen",
        },
        "modal": {
            "defaultTitle": "Ankündigung",
        },
        "table": {
            "title": "Ankündigungen",
            "column": {
                "title": "Titel",
                "datePosted": "Veröffentlichungsdatum",
                "dismissed": "Verworfen",
                "status": "Status",
                "action": "Aktion",
            },
            "status": {
                "read": "Gelesen",
                "unread": "Ungelesen",
            },
            "csv": {
                "statusRead": "Gelesen",
                "statusUnread": "Ungelesen",
                "dismissedYes": "Verworfen",
                "dismissedNo": "Nicht verworfen",
            },
            "action": {
                "view": "Ansehen",
            },
            "button": {
                "exportCsv": "CSV exportieren",
            },
        },
    },
};

export default announcementsDE;
